import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	amount: '0',
	feeData: { Amount: 0, Fee: 0 },
	isMaxAmountSetted: false,
	withdrawalId: null,
	walletAddresses: [],
	baseCurrencyAddresses: [],
};

export const topUpCardSlice = createSlice({
	name: 'topUpCard',
	initialState,
	reducers: {
		resetState: () => initialState,
		setAmount: (state, action) => {
			const { payload: amount = initialState.amount } = action;
			state.amount = amount;
		},
		setFeeData: (state, action) => {
			const { payload: feeData = initialState.feeData } = action;
			state.feeData = feeData;
		},
		setIsMaxAmountSetted: (state, action) => {
			const { payload: isMaxAmountSetted = initialState.isMaxAmountSetted } = action;
			state.isMaxAmountSetted = isMaxAmountSetted;
		},
		setWithdrawalId: (state, action) => {
			const { payload: withdrawalId = initialState.withdrawalId } = action;
			state.withdrawalId = withdrawalId;
		},
		setWalletAddresses: (state, action) => {
			const { payload: walletAddresses = initialState.walletAddresses } = action;
			state.walletAddresses = walletAddresses;
		},
		setBaseCurrencyAddresses: (state, action) => {
			const { payload: baseCurrencyAddresses = initialState.baseCurrencyAddresses } = action;
			state.baseCurrencyAddresses = baseCurrencyAddresses;
		},
	},
});
